import { isDivisible } from 'features/sport';
import { useMemo } from 'react';

export const useIsDivisible = (puntataInputValue: number) => {
  return useMemo(() => isDivisible(puntataInputValue), [puntataInputValue]);
};
